<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
          v-model="message.tradeContract.name"
          label="取引契約名"
          :readonly="true">
      </v-text-field>
    </v-col>

    <v-col cols="12">
      <v-text-field
          v-model="message.dataComponentModel.name"
          label="データ名"
          :readonly="true">
      </v-text-field>
    </v-col>

    <v-col cols="12">
      <v-text-field
          v-model="message.receiverOwner.name"
          label="利用事業者名"
          :readonly="true">
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'DeleteRequestForm',
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>
